export const AVATAR_TYPES = {
  SINGLE_AVATAR: 'single_avatar',
  GROUP_AVATAR: 'group_avatar',
}

export const AVATAR_SIZE = {
  PROFILE: 172,
  PROFILE_CORE: 126,
  EXTRA_LARGE: 80,
  LARGE: 40,
  MEDIUM: 32,
  SMALL: 24,
  EXTRA_SMALL: 20,
  SEARCH_RESULT: 64,
}

export const AVATAR_VARIANT = {
  CIRCULAR: 'circular',
  ROUNDED: 'rounded',
  SQUARE: 'square',
}
